<template>
  <div>
    <card class="card assigned-scopes-card" :title="$t('scopes')">
      <div class="assigned-scopes-card__header">
        <div class="col-sm-6 card__search">
          <SmallSearch @search="search = $event"> </SmallSearch>
        </div>
        <div class="card__right-button">
          <div class="position-relative">
            <button class="btn btn-just-icon btn-outline-warning mr-3 tooltipBtn" @click="openAdd = true">
              <i class="fas fa-plus" />
            </button>
            <div class="tooltipCustom tooltipCustom--bottom">Assign new Scope</div>
          </div>
        </div>
      </div>

      <div class="assigned-scopes-card__content">
        <div v-if="scopes && scopes.length > 0">
          <ul class="list-unstyled team-members">
            <li>
              <div class="row" v-for="(scope, index) in filteredList" v-bind:key="index">
                <div class="col-xl">
                  <label for="name" class="control-label">Name</label>
                  <p id="name" class="text-title">{{ scope.name }}</p>
                </div>

                <div class="col-md description">
                  <label for="description" class="control-label">Description</label>
                  <p id="description">{{ scope.description }}</p>
                </div>

                <div class="col-md mt-3">
                  <div class="position-relative d-inline-block">
                    <p-button type="danger" outline icon class="tooltipBtn" @click.native.prevent="setScope(scope)">
                      <i class="fa fa-times" />
                    </p-button>
                    <div class="tooltipCustom tooltipCustom--bottom">Remove Scope</div>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <div class="showAll w-full text-center">
            <!-- Show All / Hide-->
            <div v-if="!showAll && this.scopes.length > 3">
              <div @click="showAll = true">
                <p>{{ $t('show_all_scopes') }} &darr;</p>
              </div>
            </div>
            <div v-if="showAll && this.scopes.length > 3">
              <div @click="showAll = false">
                <div @click="showAll = true">
                  <p>{{ $t('Hide') }} &uarr;</p>
                </div>
              </div>
            </div>
            <!-- End Show All / Hide -->
          </div>
        </div>
        <div v-else>
          <p>{{ $t('this_company_does_not_have_any_users') }}</p>
        </div>
      </div>
    </card>

    <!-- Modals -->

    <ModalTemplate
      component-name="AddScopesModal"
      button-component-name="CreateNewButton"
      action="addScopesToRole"
      :data="{
        header: $t('assign_new_scopes'),
        for_obj: role,
      }"
      :clicked="openAdd"
      @update:field="openAdd = false"
      @submit="addScopes($event)"
    >
    </ModalTemplate>

    <ModalTemplate
      component-name="DeleteModal"
      button-component-name="DeleteButton"
      action="removeScopesFromRole"
      :data="{
        deletion_object_name: scope_name,
        deletion_object_text: $t('this_scope'),
        delete_button_title: $t('remove_scope'),
        header: $t('remove_scope'),
        placeholder: $t('remove'),
        confirmation_word: $t('remove'),
        delete_button_name: $t('remove'),
      }"
      :clicked="open_delete_modal"
      @update:field="open_delete_modal = false"
      @openButtonClicked="setScope(scope)"
      @submit="removeScope()"
    >
    </ModalTemplate>
  </div>
</template>
<script>
import ModalTemplate from '../../../components/modals/ModalTemplate';
import axiosAuth from '../../../axiosMain';
import SmallSearch from '../../../components/search/SmallSearch';
export default {
  components: { SmallSearch, ModalTemplate },
  props: {
    scopes: {
      type: Array,
    },
    role: {
      type: Object,
    },
    company: {
      type: Object,
    },
  },
  data() {
    return {
      title: 'Team members',
      openAdd: false,
      open_delete_modal: false,
      scope: null,
      scope_name: name,
      showAll: false,
      search: '',
    };
  },
  computed: {
    filteredList() {
      if (this.showAll) {
        return this.scopes.filter((scope) => {
          return scope.name.toLowerCase().includes(this.search.toLowerCase());
        });
      } else {
        return this.scopes
          .filter((scope) => {
            return scope.name.toLowerCase().includes(this.search.toLowerCase());
          })
          .slice(0, 3);
      }
    },
  },
  beforeMount() {
    this.getUsersOfRole();
  },
  methods: {
    removeScope: function () {
      axiosAuth
        .post(
          '/role_scopes/delete/' + this.role.role_id,
          {
            company_id: this.company.company_id,
            scopes: [
              {
                scope_id: this.scope.scope_id,
              },
            ],
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.getters.token,
            },
          }
        )
        .then((response) => {
          this.updateScopesList(response.data.data.scopes);
          this.$notify({
            type: 'success',
            title: this.$t('Successful'),
            text: this.$t('the_scope_was_removed'),
          });
        })
        .catch((errors) => {
          this.$notify({
            type: 'danger',
            title: this.$t('Error') + ' ' + errors.response.status,
            text: errors.response.data[0],
          });
        });
    },
    updateScopesList: function (scopes) {
      this.scopes = scopes;
    },
    setScope: function (scope) {
      this.scope = scope;
      this.scope_name = scope.name;
      this.open_delete_modal = true;
    },
    addScopes: function (event) {
      axiosAuth
        .patch('/role_scopes/' + this.role.role_id, {
          company_id: this.company.company_id,
          scopes: event,
        })
        .then((response) => {
          this.updateScopesList(response.data.data.scopes);
          this.$notify({
            type: 'success',
            title: this.$t('Successful'),
            text: this.$t('the_scopes_were_assigned'),
          });
        })
        .catch((errors) => {
          this.$notify({
            type: 'danger',
            title: this.$t('Error') + ' ' + errors.response.status,
            text: errors.response.data[0],
          });
        });
    },
    openModalCreate() {
      this.openCreate = true;
    },
  },
};
</script>
<style></style>
